import { updateOrderInfo, updateSelectedIpgId } from "appRedux/slices/orderSlice"

export async function handleOnCreateOrderQueryStarted(arg: any, { dispatch, queryFulfilled, getState }: any) {
  try {
    const { data } = await queryFulfilled
    dispatch(updateOrderInfo(data))
    dispatch(updateSelectedIpgId(data.ipgList[0].id))
  } catch (error) {
    console.error(`Error creating order with productId ${arg?.productId}:`, error)
  }
}
